<div class="grid-container" *ngIf="gon" [ngClass]="{'mobile-sidebar-open': mainService.isMobileSidebarOpen}">
  <div class="grid-item">
    <nav class="page-sidebar" id="sidebar" app-sdp-sidebar style="width: 100%;"></nav>
  </div>
  <div class="grid-item">
    <div class="sub-grid-item">
      <header class="header" app-sdp-header></header>
    </div>
    <div class="sub-grid-item">
      <router-outlet></router-outlet>
    </div>
    <div class="sub-grid-item ">
      <div class="font-13 header-bg d-flex flex-column justify-content-center align-items-center" app-sdp-footer></div>
    </div>
  </div>
  <div class="mobile-overlay" *ngIf="mainService.isMobileSidebarOpen" (click)="mainService.isMobileSidebarOpen = false">
  </div>
</div>